import http from './http'
// let baseUrl = window.SITE_CONFIG['apiURL']
/**
 *秒杀的埋点
 * id: 活动id
 * activityType: 1是专题活动，2是抢购活动
 */
export function purchaseInfoBuringPoint (id, activityType = 2) {
  http.post(`/help/order/special/activity/statistics/save`, {
    'activityId': id,
    'activityType': activityType,
    'ip': window.SITE_CONFIG['returnCitySN'] ? window.SITE_CONFIG['returnCitySN'].cip : ''
  })
}
